import { type ChangeEvent } from 'react';
import { defaultArrangedOptions } from '../countryOptions';
import { orderByLocale, removeExcludedField } from '../helpers';
import { generateInput } from '../../../../shared/utils/Form/useForm';

export const getFranceSpecificOptions = (
  inputs: Array<Record<string, unknown>>,
  fields: Record<string, unknown>,
  onValuesChange: (newValue: unknown) => void
) => {
  const newInputs = removeExcludedField(inputs, ['bankAccountNumber', 'email', 'personalId']);

  newInputs.push(
    generateInput((e: ChangeEvent<HTMLInputElement>) => {
      onValuesChange({
        target: { name: 'email', value: e.target.value }
      });
      onValuesChange({
        target: { name: 'personalId', value: e.target.value }
      });
    }, fields.personalId)({
      name: 'email',
      label: 'email',
      md: 6
    })
  );

  orderByLocale(defaultArrangedOptions, newInputs);

  return newInputs;
};
